import { combineReducers } from 'redux';
import educations from './educations';

const reducers = { educations };
export default combineReducers(reducers);
